import React, { useState } from "react";
// import TimePicker from 'react-time-picker';
import TimePicker from 'react-bootstrap-time-picker';
import { timeFromInt } from 'time-number';

// @ aperturaJSON : Json from database
// @ aperturaTT: fn
const WeekTable = ({aperturaJSON, aperturaTT}) => {


  const [inputList, setInputList] = useState(aperturaJSON);
  // console.log({aperturaJSON});

  // Manage checkboxes for days of week
  const handleCheckboxChange = (e) => {
    const { name, checked } = e.target;
    // console.log(name);
    // console.log(checked);

    const arr = name.split('_');
    // console.log(arr[0]);

    // Set the list
    const list = [...inputList];
    list[arr[0]].open = checked
    setInputList(list);
    aperturaTT(list);

  };

  const onChangeClock = (event, name) => {
    // console.log(event);
    // console.log(name);

    const arr = name.split('_');

    const list = [...inputList];
    // console.log(list[arr[0]].hours.[arr[1]].[arr[2]]);
    list[arr[0]].hours.[arr[1]].[arr[2]] = timeFromInt(event);
    // list[arr[0]].hours.[arr[1]].[arr[2]] = "16:30";
    setInputList(list);
    aperturaTT(list);
  }

  return (
    <div className="table-responsive">
    <table className="table table-sm table-striped">
      <thead>
        <tr>
          <th></th>
          <th className="small" colSpan="2">Mattino</th>
          <th className="small" colSpan="2">Pomeriggio</th>
        </tr>
        <tr>
          <th className="small">Giorno</th>
          <th className="small">Dalle</th>
          <th className="small">Alle</th>
          <th className="small">Dalle</th>
          <th className="small">Alle</th>
        </tr>
      </thead>
      <tbody>

        {inputList.map((x, i) => {

          // console.log(x);
          // console.log(check);
          // console.log(check[x.id]);

          return(
            <tr key={x.id}>
              <td>
                <div className="form-check">
                  <input
                    type="checkbox"
                    className="form-check-input"
                    checked={x.open}
                    name = {x.id}
                    onChange={event => handleCheckboxChange(event)}
                  />
                  <span>{ x.name }</span>
                </div>
              </td>
              <td hidden={!x.open}>
                <TimePicker
                  format= {24}
                  start= "00:00"
                  end= "23:59"
                  step= {30}
                  name={x.id+"_morning_open"}
                  onChange={(event, name) => onChangeClock(event, x.id+"_morning_open")}
                  value={x.hours.morning.open}
                />
              </td>
              <td hidden={!x.open}>
                <TimePicker
                  format= {24}
                  start= "00:00"
                  end= "23:59"
                  step= {30}
                  name={x.id+"_morning_close"}
                  onChange={(event, name) => onChangeClock(event, x.id+"_morning_close")}
                  value={x.hours.morning.close}
                />
              </td>
              <td hidden={!x.open}>
                <TimePicker
                  format= {24}
                  start= "00:00"
                  end= "23:59"
                  step= {30}
                  name={x.id+"_aftern_open"}
                  onChange={(event, name) => onChangeClock(event, x.id+"_aftern_open")}
                  value={x.hours.aftern.open}
                />

              </td>
              <td hidden={!x.open}>
                <TimePicker
                  format= {24}
                  start= "00:00"
                  end= "23:59"
                  step= {30}
                  name={x.id+"_aftern_close"}
                  onChange={(event, name) => onChangeClock(event, x.id+"_aftern_close")}
                  value={x.hours.aftern.close}
                />
              </td>
              <td hidden={x.open} colSpan="4"><input type="text" name={x.id+"_close"} value="chiuso" disabled/></td>
            </tr>
          );
        })}
      </tbody>
    </table>
  </div>
  );
};

export default WeekTable;
